module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_sns_01-9c57bdf924d11934208fd2ed315ad2cc.jpg";